/**
 * Three-month lecturer calendar window: previous month start through end of next month.
 */
export const buildSlotWindowParams = (cursorMonth) => {
  const monthStart = cursorMonth.startOf('month');
  return {
    startAfter: monthStart.subtract(1, 'month').toISOString(),
    endBefore: monthStart.add(1, 'month').endOf('month').toISOString(),
  };
};
